<div class="section-banner">
    <div class="wide-content-wrapper-cnt">
        <div class="section-banner__inner">
            <div class="section-banner__title" v-html="title"></div>
            <div class="section-banner__description" v-html="description"></div>
        </div>
    </div>
</div>